module.exports = __webpack_public_path__ + "34736292/img/placeholder.888fcd0b.svg";